import { render, staticRenderFns } from "./App.vue?vue&type=template&id=68d8f5ca"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=68d8f5ca&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.8_css-loader@6.11.0_webpack@5.97.1__ejs@3.1.10_lodas_y7tq6ywkbl267o2pnf7uinybmq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports